import { render } from "./CookieMessage.vue?vue&type=template&id=f2e4d654&scoped=true"
import script from "./CookieMessage.vue?vue&type=script&lang=js"
export * from "./CookieMessage.vue?vue&type=script&lang=js"

import "./CookieMessage.vue?vue&type=style&index=0&id=f2e4d654&lang=scss&scoped=true"

import exportComponent from "/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2e4d654"]])

export default __exports__